import * as motion from "motion/react-client";
import AppIcon from "../Icon";
import PrimaryButton from "../button/PrimaryButton";
import { ReactNode } from "react";

interface PageFeedbackProps {
    children: ReactNode;
    title: string;
    type?: "success" | "error" | "warning" | undefined;
}

export default function PageFeedback(props: PageFeedbackProps) {
    const { type, title, children  } = props;

    return (
        <motion.div
            className={`w-[600px] sm:max-w-md flex flex-col items-center mt-10 p-10 md:px-12 bg-white dark:bg-gray-800 shadow-md 
                overflow-hidden sm:rounded-lg group ${type}`}
            initial={{opacity: 0}}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
        >
            <div 
                className="size-[70px] bg-green-400 group-[.error]:bg-red-500 group-[.warning]:bg-yellow-500 rounded-full flex justify-center items-center"
            >
                <AppIcon icon="check" className="size-[80px] text-white text-center"/>
            </div>
            <h2 className="text-lg md:text-[23px] font-bold text-green-400 group-[.error]:text-red-500 text-center mt-2 mb-6">
                { title }
            </h2>
            <div className="text-gray-500 dark:text-gray-400 text-lg text-center">
                { children }
            </div>
        </motion.div>
    );
}